import {
  FormLayout,
  Panel,
  PanelSection,
  PanelHeader,
  PanelTitle,
  PanelDescription,
} from '@customerio/pluma-components/react';
import { TextArea, withForm } from '@/components/form';
import { aiBusinessProfileFormOptions } from '../helpers/form';
import { BasicInfoFields } from '@/features/business-profile-forms';

export const BasicInfo = withForm({
  ...aiBusinessProfileFormOptions,
  props: {
    canEdit: true,
  },
  render: function BasicInfo({ form, canEdit }) {
    return (
      <Panel>
        <PanelHeader>
          <PanelTitle>Basic info</PanelTitle>
          <PanelDescription>Tell us about your company, what you do, and who you serve.</PanelDescription>
        </PanelHeader>
        <PanelSection>
          <FormLayout>
            <BasicInfoFields form={form} isDisabled={canEdit === false} />
            <TextArea
              name="longDescription"
              api={form}
              label="Business description"
              placeholder="Briefly describe what your business does and the value you provide"
              minRows={4}
              description="Explain what your business does, the products or services you offer, and the value you provide to customers"
              isDisabled={canEdit === false}
            />
            <TextArea
              name="audience"
              api={form}
              label="Audience"
              placeholder="Who are your primary customers or users?"
              minRows={4}
              description='Describe your target audience, customer segments, or user personas (e.g. "Small business owners, marketing managers at mid-size companies, developers")'
              isDisabled={canEdit === false}
            />
          </FormLayout>
        </PanelSection>
      </Panel>
    );
  },
});
